import React, { useState } from 'react';

import BlurPopup from 'components/BlurPopup';
import { Button } from 'components/Buttons/Button';
import { ButtonType } from 'enums/ButtonType';
import Loader from 'components/Loader';
import * as notificationManager from 'notifications/index';
import { applicationApi } from 'api/ApplicationApi';

import styles from './ProsperJointTransition.module.scss';

interface ProsperJointTransitionDialogProps {
  isModalOpen: boolean;
  applicationId: string;
  onClose: () => void;
}

const ProsperJointTransitionDialog = ({ isModalOpen, applicationId, onClose }: ProsperJointTransitionDialogProps) => {
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleContinue = async () => {
    try {
      setIsRedirecting(true);

      const { prosperJointRedirectUrl } = await applicationApi.storeProsperJointRedirectDatetime(applicationId);

      window.location.href = prosperJointRedirectUrl;
    } catch (error) {
      notificationManager.notifyFailure(notificationManager.FailureNotificationType.UnknownError);
    } finally {
      onClose();
      setIsRedirecting(false);
    }
  };

  return (
    <BlurPopup open={isModalOpen} onClose={onClose} blurDeep={2}>
      {isRedirecting ? (
        <div className={styles.dialogLoader}>
          <Loader />
        </div>
      ) : (
        <div className={styles.dialog}>
          <div className={styles.dialogInfo}>
            <h1 className={styles.dialogTitle}>Before You Continue</h1>
            <div className={styles.dialogBody}>
              <p className={styles.dialogText}>
                You will now be leaving the HFS Financial system and go to our partner's site to complete your credit
                inquiry where you will have the opportunity to get funding for your home project.
              </p>
              <p className={styles.dialogTextBold}>Click the "Continue" button if you wish to proceed.</p>
            </div>
          </div>
          <div className={styles.dialogButtons}>
            <Button buttonType={ButtonType.Primary} className={styles.dialogButton} onClick={handleContinue}>
              Continue
            </Button>
            <Button buttonType={ButtonType.Secondary} className={styles.dialogButton} onClick={onClose}>
              Cancel
            </Button>
          </div>
        </div>
      )}
    </BlurPopup>
  );
};

export default ProsperJointTransitionDialog;
